import { Theme, ThemeOptions } from "@mui/material";

const shadows = (theme: Theme) => {
  const defaultShadows = [...theme.shadows];
  defaultShadows[1] = "0px 0px 20px rgba(40, 41, 44, 0.12);";
  defaultShadows[2] = "0px 3px 14px rgba(0, 0, 0, 0.12);";

  return defaultShadows as ThemeOptions["shadows"];
};

export { shadows };
